import { actions } from 'shared/store'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { paths } from 'config'

export const useLogout = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const handleLogout = async () => {
    await dispatch(actions.auth.logout())
    await dispatch(actions.root.clearState())
    dispatch(actions.companies.clearCompanySelection())

    history.replace({ pathname: paths.login, state: undefined })
  }

  return { handleLogout }
}
